import type { FC } from 'react'
import { FaCompress, FaExpand } from 'react-icons/fa6'
import ToolbarButton from './ToolbarButton'

type FocusModeButtonProps = {
  isFocusMode: boolean
  onToggle: () => void
}

const FocusModeButton: FC<FocusModeButtonProps> = ({ isFocusMode, onToggle }) => {
  return (
    <ToolbarButton
      onClick={onToggle}
      ariaLabel={isFocusMode ? 'Odak modundan çık' : 'Odak moduna gir (tam ekran okuma)'}
      title={isFocusMode ? 'Odak modundan çık (Esc)' : 'Odak moduna gir (tam ekran okuma)'}
      className={isFocusMode ? 'text-emerald-500 hover:text-emerald-600' : ''}
    >
      {isFocusMode ? <FaCompress /> : <FaExpand />}
    </ToolbarButton>
  )
}

export default FocusModeButton
